/**
 * MAISON PRIMITIVE - JavaScript Final V10
 * Version : 10.0 (Version nettoyée et complète)
 */

document.addEventListener('DOMContentLoaded', () => {

  /* === Effet de parallaxe sur le Hero === */
  const heroBackground = document.querySelector('.hero-background');
  if (heroBackground) {
    window.addEventListener('scroll', () => {
      const parallax = window.pageYOffset * 0.5;
      heroBackground.style.transform = `translateY(${parallax}px)`;
    });
  }

  /* === Apparition fluide du logo et du titre === */
  const heroElements = document.querySelectorAll('.logo, .hero-title');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  heroElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
    observer.observe(el);
  });

  /* === Animation du header au scroll === */
  const navbar = document.querySelector('.navbar, .header, .site-header');
  if (navbar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    });
  }

  /* === NETTOYAGE DES FLÈCHES DOUBLES === */
  
  document.querySelectorAll('.dropdown').forEach(dropdown => {
    const arrows = dropdown.querySelectorAll('.arrow, .dropdown-arrow, span');
    arrows.forEach(arrow => {
      if (arrow.textContent.trim() === '▼' || 
          arrow.textContent.trim() === '▲' || 
          arrow.textContent.trim() === '▶' ||
          arrow.textContent.trim() === '◀') {
        arrow.remove();
      }
    });
  });
  
  document.querySelectorAll('.dropdown-item-with-submenu').forEach(item => {
    const arrows = item.querySelectorAll('.arrow, span');
    arrows.forEach(arrow => {
      if (arrow.textContent.trim() === '▶' || arrow.textContent.trim() === '◀') {
        arrow.remove();
      }
    });
  });

  /* === GESTION SIMPLIFIÉE DES DROPDOWNS DESKTOP === */
  
  let dropdownTimeout;
  let submenuTimeout;
  
  // Gestion du dropdown principal
  const dropdown = document.querySelector('.dropdown');
  const dropdownMenu = document.querySelector('.dropdown-menu');
  
  if (dropdown && dropdownMenu) {
    // Empêcher le clic sur "NOS OBJETS"
    const link = dropdown.querySelector('.nav-link, .dropdown-toggle');
    if (link) {
      link.addEventListener('click', e => {
        if (window.innerWidth > 1024) {
          e.preventDefault();
        }
      });
    }
    
    // Hover simple avec délai court
    dropdown.addEventListener('mouseenter', () => {
      if (window.innerWidth > 1024) {
        clearTimeout(dropdownTimeout);
        dropdown.classList.add('hover');
      }
    });
    
    dropdown.addEventListener('mouseleave', () => {
      if (window.innerWidth > 1024) {
        dropdownTimeout = setTimeout(() => {
          dropdown.classList.remove('hover');
        }, 150);
      }
    });
  }
  
  // Gestion du sous-menu PORTES - SIMPLIFIÉ
  const submenuItem = document.querySelector('.dropdown-item-with-submenu');
  const submenu = document.querySelector('.submenu');
  
  if (submenuItem && submenu) {
    submenuItem.addEventListener('mouseenter', () => {
      if (window.innerWidth > 1024) {
        clearTimeout(submenuTimeout);
        submenuItem.classList.add('hover');
      }
    });
    
    submenuItem.addEventListener('mouseleave', () => {
      if (window.innerWidth > 1024) {
        submenuTimeout = setTimeout(() => {
          submenuItem.classList.remove('hover');
        }, 150);
      }
    });
    
    // Maintenir ouvert quand on survole le sous-menu
    submenu.addEventListener('mouseenter', () => {
      clearTimeout(submenuTimeout);
      submenuItem.classList.add('hover');
    });
    
    submenu.addEventListener('mouseleave', () => {
      submenuTimeout = setTimeout(() => {
        submenuItem.classList.remove('hover');
      }, 150);
    });
  }

  /* === GESTION DU MENU MOBILE === */
  
  const mobileMenuButton = document.querySelector('#mobile-menu, .menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  
  // Ouvrir/fermer le menu mobile
  if (mobileMenuButton && mobileNav) {
    mobileMenuButton.addEventListener('click', () => {
      mobileMenuButton.classList.toggle('active');
      mobileNav.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }

  // Fermer en cliquant sur les liens (mais pas les toggles)
  mobileNav?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      if (mobileMenuButton) mobileMenuButton.classList.remove('active');
      mobileNav.classList.remove('active');
      document.body.classList.remove('menu-open');
    });
  });

  /* === TOGGLES MOBILE - VERSION UNIFIÉE === */
  
  // Attendre que le DOM soit complètement prêt
  setTimeout(() => {
    
    // Toggle principal NOS OBJETS
    const mobileDropdown = document.querySelector('.mobile-dropdown');
    const mobileToggle = document.querySelector('.mobile-dropdown-toggle');
    
    if (mobileToggle && mobileDropdown) {
      // Nettoyer les anciens listeners
      const newToggle = mobileToggle.cloneNode(true);
      mobileToggle.parentNode.replaceChild(newToggle, mobileToggle);
      
      newToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        mobileDropdown.classList.toggle('active');
        
        // Rotation de la flèche
        const arrow = newToggle.querySelector('.dropdown-arrow');
        if (arrow) {
          const isOpen = mobileDropdown.classList.contains('active');
          arrow.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
        }
        
        console.log('📱 NOS OBJETS toggle:', mobileDropdown.classList.contains('active') ? 'ouvert' : 'fermé');
      });
    }
    
    // Toggle PORTES
    const mobileSubDropdown = document.querySelector('.mobile-sub-dropdown');
    const subToggle = document.querySelector('.mobile-sub-dropdown-toggle');
    
    if (subToggle && mobileSubDropdown) {
      // Nettoyer les anciens listeners
      const newSubToggle = subToggle.cloneNode(true);
      subToggle.parentNode.replaceChild(newSubToggle, subToggle);
      
      newSubToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        mobileSubDropdown.classList.toggle('active');
        
        // Rotation de la flèche
        const arrow = newSubToggle.querySelector('.sub-arrow');
        if (arrow) {
          const isOpen = mobileSubDropdown.classList.contains('active');
          arrow.style.transform = isOpen ? 'rotate(90deg)' : 'rotate(0deg)';
        }
        
        // S'assurer que le parent est ouvert
        if (mobileSubDropdown.classList.contains('active')) {
          mobileDropdown?.classList.add('active');
          const parentArrow = document.querySelector('.dropdown-arrow');
          if (parentArrow) {
            parentArrow.style.transform = 'rotate(180deg)';
          }
        }
        
        console.log('🔧 PORTES toggle:', mobileSubDropdown.classList.contains('active') ? 'ouvert' : 'fermé');
      });
    }
    
  }, 500); // Délai de 500ms pour s'assurer que tout est prêt

  /* === COMPATIBILITÉ SHOPIFY === */
  
  const shopifyDetails = document.querySelectorAll('details.header__menu-item');
  
  shopifyDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    
    if (summary && window.innerWidth > 1024) {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });
      
      detail.addEventListener('mouseenter', () => {
        detail.setAttribute('open', '');
      });
      
      detail.addEventListener('mouseleave', () => {
        detail.removeAttribute('open');
      });
    }
  });

  /* === RESPONSIVE === */
  
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth > 1024) {
        // Fermer le menu mobile
        const hamburger = document.querySelector('.menu-toggle');
        const mobileNavMenu = document.querySelector('.mobile-nav');
        
        if (hamburger && mobileNavMenu) {
          hamburger.classList.remove('active');
          mobileNavMenu.classList.remove('active');
          document.body.classList.remove('menu-open');
        }
        
        // Réinitialiser les dropdowns mobile
        document.querySelectorAll('.mobile-dropdown, .mobile-sub-dropdown').forEach(dropdown => {
          dropdown.classList.remove('active');
        });
        
        // Réinitialiser les flèches
        document.querySelectorAll('.dropdown-arrow, .sub-arrow').forEach(arrow => {
          arrow.style.transform = 'rotate(0deg)';
        });
      }
    }, 250);
  });

  /* === CSS HOVER FIX === */
  
  const style = document.createElement('style');
  style.textContent = `
    /* Desktop hover states */
    .dropdown.hover .dropdown-menu {
      opacity: 1;
      visibility: visible;
      pointer-events: all;
      transform: translateX(-50%) translateY(0);
    }
    
    .dropdown-item-with-submenu.hover .submenu {
      opacity: 1;
      visibility: visible;
      pointer-events: all;
      transform: translateX(0);
    }
    
    /* Flèches en marron dans le menu mobile */
    .mobile-dropdown-toggle,
    .mobile-dropdown-toggle .dropdown-arrow,
    .mobile-sub-dropdown-toggle,
    .mobile-sub-dropdown-toggle .sub-arrow {
      color: var(--color-main) !important;
    }
    
    /* Mobile centrage hamburger */
    @media (max-width: 1024px) {
      .nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
      }
      
      .menu-toggle {
        position: relative;
        left: 0;
        margin: 0;
        order: 0;
      }
      
      .nav-icons {
        order: 2;
        margin-left: auto;
      }
    }
  `;
  document.head.appendChild(style);

  /* === DEBUG === */
  
  console.log('🚀 Maison Primitive - Menu V10 initialisé');
  console.log('📱 Mode mobile:', window.innerWidth <= 1024);
  
  // Vérifier les éléments après un court délai
  setTimeout(() => {
    const checks = {
      'Menu mobile': !!document.querySelector('.mobile-nav'),
      'Dropdown mobile': !!document.querySelector('.mobile-dropdown'),
      'Toggle NOS OBJETS': !!document.querySelector('.mobile-dropdown-toggle'),
      'Submenu mobile': !!document.querySelector('.mobile-submenu'),
      'Sub-dropdown PORTES': !!document.querySelector('.mobile-sub-dropdown'),
      'Sub-submenu': !!document.querySelector('.mobile-sub-submenu')
    };
    console.table(checks);
  }, 1000);

});

/* === FONCTIONS UTILITAIRES === */

// Fermer le menu mobile
window.closeMobileMenu = function() {
  const hamburger = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  
  if (hamburger && mobileNav) {
    hamburger.classList.remove('active');
    mobileNav.classList.remove('active');
    document.body.classList.remove('menu-open');
  }
};

// Réinitialiser tous les menus
window.resetMenus = function() {
  // Desktop
  document.querySelectorAll('.dropdown, .dropdown-item-with-submenu').forEach(element => {
    element.classList.remove('hover', 'active');
  });
  
  // Mobile
  document.querySelectorAll('.mobile-dropdown, .mobile-sub-dropdown').forEach(dropdown => {
    dropdown.classList.remove('active');
  });
  
  // Réinitialiser les flèches
  document.querySelectorAll('.dropdown-arrow, .sub-arrow').forEach(arrow => {
    arrow.style.transform = 'rotate(0deg)';
  });
  
  window.closeMobileMenu();
};

// Vérifier l'état des menus
window.checkMenuState = function() {
  const state = {
    'Menu mobile ouvert': document.querySelector('.mobile-nav')?.classList.contains('active'),
    'Dropdown mobile existe': !!document.querySelector('.mobile-dropdown'),
    'Submenu mobile existe': !!document.querySelector('.mobile-submenu'),
    'Dropdown mobile ouvert': document.querySelector('.mobile-dropdown')?.classList.contains('active'),
    'Sub-dropdown mobile ouvert': document.querySelector('.mobile-sub-dropdown')?.classList.contains('active')
  };
  console.table(state);
  return state;
};